import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllQuarters } from "../../../redux/features/appraisalSlice";
import { useSelector } from "react-redux";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Quarter_Table_Head } from "../../../components/datagrid/appraisal/QuarterTableHead";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { Box, MenuItem, TextField } from "@mui/material";
import AddQuarter from "./AddQuarter";

const QuarterLandingView = () => {
  const dispatch = useDispatch();
  const { loading, quarters } = useSelector((state) => state.appraisal);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  // Status filter for the quarters list. 1 = Active (default), 0 = Inactive, "all" = All.
  // "all" is a sentinel so the dropdown can display the word "All"; it is converted to an
  // empty status (no filter) before the request, which makes the backend return active + inactive.
  const [statusFilter, setStatusFilter] = useState(1);

  const data = {
    search: search,
    page: pageNum,
    limit: gridSize,
    appraisal_tag_status: statusFilter === 'all' ? '' : statusFilter,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getAllQuarters(data));
    }
  }, [search, pageNum, gridSize, statusFilter]);

  return (
    <GlobalWrapper
      title={"Quarters"}
      actions={<AddQuarter dispatchParams={data} />}
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        {/* Filter to show Active / Inactive / All quarters (defaults to Active) */}
        <Box sx={{ mb: 2 }}>
          <TextField
            select
            size="small"
            label="Status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            sx={{ width: 200 }}
          >
            <MenuItem value={1}>Active</MenuItem>
            <MenuItem value={0}>Inactive</MenuItem>
            <MenuItem value={"all"}>All</MenuItem>
          </TextField>
        </Box>
        <GlobalDatagrid
          tableHead={Quarter_Table_Head(data)}
          rows={quarters?.data}
          meta={quarters?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="appraisal_tag_id"
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default QuarterLandingView;
